module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-cols-num clearfix"
  }, [_c('div', {
    staticClass: "select",
    style: ({
      background: _vm.backColor
    })
  }, [_c('span', {
    staticClass: "down",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.down()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Num),
      expression: "Num"
    }],
    staticClass: "select-input",
    class: {
      show: _vm.show
    },
    attrs: {
      "type": "text",
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.Num)
    },
    on: {
      "blur": function($event) {
        return _vm.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Num = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    ref: "ul"
  }, _vm._l((_vm.numList), function(i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "unit",
    style: (_vm.unitSize == '01' ? 'font-size:14px' : '')
  }, [_vm._v(_vm._s(_vm.unit))])]), _vm._v(" "), _c('span', {
    staticClass: "up",
    class: {
      'up-disabled': _vm.Num >= _vm.limit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.up()
      }
    }
  }, [_vm._v("+")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62021032","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputNum.vue
// module id = 662
// module chunks = 0